import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { FC, useEffect, useMemo } from 'react'

import Meta from '@/components/Meta'
import SideTabs from '@/components/SideTabs'

import { TextDataType } from '@/types/TextData'

import styles from './Network.module.scss'
import { useTexts } from '@/bus/texts'
import { useUi } from '@/bus/ui'
import Section from '@/contents/Network/subcomponents/Section'
import { AboutNetwork } from '@/sections'

interface ContentProps {
  [key: string]: string | string[]
}

interface Props {
  data?: TextDataType
}

export const Network: FC<Props> = ({ data = {} }) => {
  const router = useRouter()
  const id = useMemo(() => router?.query?.id, [router.query])

  const {
    i18n: { language = 'en' }
  } = useTranslation()

  const { setSettings } = useUi()
  const { getTextsBySlug, data: textData = {}, clearTexts } = useTexts()

  useEffect(() => {
    getTextsBySlug({ slug: 'network-page-' + id, lang: language })
    setSettings({ backButton: true })

    return () => {
      setSettings({ backButton: false })
      clearTexts()
    }
    // eslint-disable-next-line
  }, [])

  const {
    children = [],
    title = '',
    content = '',
    meta = {}
  } = useMemo(() => ({ ...data, ...textData }), [data, textData])

  return (
    <div className={styles['network-wrapper']}>
      <Meta {...meta} />
      <AboutNetwork id={id as string} title={title} content={content} />
      <section className={styles['network']}>
        <div className={styles['network__side']}>
          <SideTabs items={children} />
        </div>
        <div className={styles.network__content}>
          {children.map(({ content = '', slug = '' }) => (
            <Section key={slug} slug={slug} content={content} />
          ))}
        </div>
      </section>
    </div>
  )
}
